import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/messages_/$threadId')({
  component: RedirectToMessages,
});

function RedirectToMessages() {
  return <Navigate to="/messages" replace />;
}
